/**
 *  Wrapper around JSON.parse that captures exceptions during parsing,
 * so we can safely perform this operation.
 *
 * @param {string} input - Stringified JSON that we'd like to convert to an object.
 *
 * @returns {object|object[]|undefined} Input converted to object or array format if
 *  parse is successful. If parse failed, will return nothing.
 *
 * @example Example with valid input:
 *  > Usage: parseJson('{"item": "hello"}')
 *  > Output: { item: "hello" }
 *
 * @example Example with malformed input:
 *  > Usage: parseJson("[dumb]")
 *  > Output: undefined
 */
export const secureJsonParse = <T>(input: string): T | undefined => {
  try {
    if (input) {
      return JSON.parse<T>(input);
    }
  } catch {
    console.error(`Failed to parse JSON: ${input}`);
  }
};
